<template>
  <label
    :for="id"
    class="form__select-label"
  >
    <span
      v-if="!labelHidden"
      :class="['form__select-label-text', { 'form__select-label-text--required': required }]"
    >
      {{ label }}
    </span>
    <span class="form__select-icon-wrapper">
      <select
        :id="id"
        :name="name"
        :class="['form__select', 'form__select-title', { 'form__select-title--default': titleDefaultSelected, 'form__select--error': hasError, 'form__select--success': isValid }]"
        v-on="$listeners"
      >
        <option
          v-if="defaultEmptyOption"
          value=""
        />
        <option
          v-for="option in options"
          :key="option[optionId]"
          :value="option[optionValue]"
        >
          {{ option[optionLabel] }}
        </option>
      </select>
      <svg
        v-if="isValid"
        width="32px"
        height="32px"
        viewBox="0 0 32 32"
        class="select__icon select__icon--checkmark">
        <use xlink:href="#checkmarkIcon" />
      </svg>
    </span>

    <span
      v-show="error && error.length"
      class="form__sublabel form__sublabel--error"
      v-html="error"
    />
  </label>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "FieldSelect",
  props: {
    defaultEmptyOption: {
      type: Boolean,
      default: false
    },
    error: {
      type: [String, Boolean],
      default: ""
    },
    id: {
      type: String,
      default: ""
    },
    label: {
      required: true,
      type: String
    },
    labelHidden: {
      type: Boolean,
      default: false
    },
    name: {
      required: true,
      type: String
    },
    options: {
      required: true,
      type: Array
    },
    optionId: {
      type: String,
      default: "id"
    },
    optionLabel: {
      type: String,
      default: "label"
    },
    optionValue: {
      type: String,
      default: "value"
    },
    required: {
      type: Boolean,
      default: false
    },
    value: {
      type: String,
      default: ""
    },
    validateable: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...mapGetters({
      titleDefaultSelected: "forms/titleDefaultSelected"
    }),
    hasError() {
      return this.validateable && !!this.error;
    },
    isValid() {
      return this.validateable && !this.hasError && this.value.length > 0;
    }
  }
};
</script>

<style lang="scss" scoped>
label {
  margin: 1rem 0;
}
</style>
